<template>
  <div></div>
</template>
<script>
export default {
  data () {
    return {
      component: {
        class: 'col-12 mt-3',
        componentName: 'LmFormSeparator'
      }
    }
  },
  created () {
    this.$emit('input', this.component)
  }
}
</script>
